module.exports = __webpack_public_path__ + "static/media/logoo.2aa4d737.png";


//////////////////
// WEBPACK FOOTER
// ./src/logoo.png
// module id = 191
// module chunks = 0